module.exports = __webpack_public_path__ + "static/appstore-9560ddd892f2c752bcfeeaec557d0168.png";